import React from 'react';
import DialsSection from '../components/home/DialsSection';
import RecommendationsCard from '../components/supplements/RecommendationsCard';

// "You" — the flagship: the digital twin. Your measured self across time, per
// metric, with the real trajectory chart, this week's graded prediction, and
// the reachable Next / Ultimate targets. (Internally still the "twin".)

const YouPage = () => {
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <div className="mb-6">
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-gray-900 dark:text-white">
          You
        </h1>
        <p className="mt-2 text-base text-stone-600 dark:text-stone-300">
          Now, and where you're heading — your measured self across time.
        </p>
      </div>
      <DialsSection />
      <div className="mt-8">
        <RecommendationsCard title="Supplement suggestions" showGoalPicker />
      </div>
    </div>
  );
};

export default YouPage;
